import { XLink } from '@adornis/chemistry/elements/components/x-link.js';
import { customElement } from 'lit/decorators.js';

@customElement('tr-link')
export class TrLink extends XLink {
  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          'text-decoration': 'underline',
          color: this.colors.accent.shade(500),
        },
        ':host(:hover)': {
          color: this.colors.accent.shade(700),
        },
        // do not undeline icons
        ':host > tr-icon, :host > x-icon': {
          'text-decoration': 'unset',
        },
        a: {
          width: '100%',
        },
      },
    ];
  }
}
